import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

export const policyDetailsGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  const policyTerm = route.queryParamMap.get('PolicyTerm');
  const policyNumber = route.queryParamMap.get('PolicyNumber');

  if (!policyTerm || !policyNumber) {
    router.navigate(['/']);
    return false;
  }

  return true;
};